// @flow
import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Widget from 'app/components/Widget';
import BulletList from 'app/components/BulletList';
import styles from './WidgetLatestVideos.styles';
import api from 'utils/API';
  
class WidgetLatestVideos extends React.Component<Props> {
  unmounted = false;

  constructor(props) {
    super(props);

    this.state = {
      list: []
    };
  }

  componentDidMount() {
    api.post('/category/%D9%88%DB%8C%D8%AF%DB%8C%D9%88', {
      id: 'ویدیو',
      page: 1,
      count: 5
    })
    .then(response => {
      if (this.unmounted) {
        return;
      }
      const list = response.data.list || [];
      this.setState({list});
    });
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  render() {
    return (
      <Widget gray title='ویدئو'>
        <BulletList list={this.state.list} />
      </Widget>
    );
  }
}

const Component = withStyles(styles)(WidgetLatestVideos);
export {Component as WidgetLatestVideos}